/*
pending withdrawals.js

This module state contains a list of withdrawals data sorted on id.
Whenever an action is received with an id, the selected is set to this id, and
then the view is updated.

*/

import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view.js';

const register = dataflow.register;

const state = {
	selected: {
		id: -1
	},
	empty: false,
	by_id: null
};

function withdrawalsExists() {
	let exists = false;
	if (state.by_id) {
		Object.keys(state.by_id).forEach((key) => {
			if (state.by_id[key]) {
				exists = true;
			}
		});
	}
	return exists;
}

function viewUpdate() {
	const exists = withdrawalsExists();
	state.empty = !exists;
	view.update({
		pending_withdrawals: state
	});
}

function deleteIfSuccessful(data) {
	let withdrawId = null;
	if (data.success) {
		withdrawId = data.withdrawId;
		if (state.by_id && state.by_id[withdrawId]) {
			state.by_id[withdrawId] = null;
		} else {
			console.warn('pending_withdrawals:deleteIfSuccesful: can not delete:', withdrawId);
		}
		viewUpdate();
	} else {
		console.error('pending_withdrawals:119:deleteIfSuccesful: can not delete', data);
	}
}

function parseToState(data) {
	// the entire state can not be replaced. The by_id sorting and selected key will be deleted. TODO: state.by_id = ...
	state.by_id = (data && data.by_id) || null;
	viewUpdate();
	actions.pendingWithdrawals(state);
}

function registerActions() {
	function pendingWithdrawals(payload) {
		if (payload.type === constants.FETCH_PENDING_WITHDRAWALS) {
			parseToState(payload.data);
		}
		if (payload.type === constants.FETCH_CANCEL_WITHDRAW) {
			deleteIfSuccessful(payload.data);
		}
		if (payload.type === constants.VIEW_NAV) {
			state.selected.id = -1;
			actions.pendingWithdrawals(state);
			viewUpdate();
		}
	}
	register(pendingWithdrawals);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/pendingwithdrawals/lib/pending-withdrawals.js